import React from 'react';

const testimonials = [
  {
    quote: '"Square Production turned our outdated legacy system into a modern, blazing-fast platform. User engagement jumped 340% in the first quarter after launch."',
    initials: 'JR',
    name: 'James Rodriguez',
    role: 'CTO, FinanceHub',
    avatarBg: 'rgba(232,85,61,0.1)',
    avatarColor: '#e8553d',
    delay: 'rv-d1',
  },
  {
    quote: '"They understood our healthcare compliance needs from day one and delivered a platform that\'s both beautiful and HIPAA-compliant. A rare find in this space."',
    initials: 'SP',
    name: 'Sarah Patel',
    role: 'CEO, HealthFirst',
    avatarBg: 'rgba(34,197,94,0.1)',
    avatarColor: '#22c55e',
    delay: 'rv-d2',
  },
  {
    quote: '"Their cloud migration cut our infrastructure costs by 60% while actually improving performance. Working with Square felt like having an elite in-house team."',
    initials: 'MK',
    name: 'Michael Kim',
    role: 'VP Engineering, CloudNine',
    avatarBg: 'rgba(167,139,250,0.1)',
    avatarColor: '#a78bfa',
    delay: 'rv-d3',
  },
];

function Testimonials() {
  return (
    <section className="section">
      <div className="section-inner">
        <div className="section-header-center rv">
          <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'inline-block' }}>Client Voices</span>
          <h2 className="section-title">Trusted by teams<br />who ship fast</h2>
        </div>

        <div className="testi-grid">
          {testimonials.map((t, i) => (
            <div key={i} className={`testi-card rv ${t.delay}`}>
              <div className="testi-stars">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="fa-solid fa-star"></i>
                ))}
              </div>
              <p className="testi-quote">{t.quote}</p>
              <div className="testi-author">
                <div className="testi-avatar" style={{ background: t.avatarBg, color: t.avatarColor }}>
                  {t.initials}
                </div>
                <div>
                  <p className="testi-author-name">{t.name}</p>
                  <p className="testi-author-role">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
